module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('steps', {
    attrs: {
      "currentStep": _vm.currentStep
    },
    on: {
      "switchStep": _vm.switchStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [(_vm.step === _vm.currentStep) ? _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.readyToSave($event)
      },
      "input": function($event) {
        return _vm.productAcivateUpdateFlag('schedule')
      }
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-end align-items-center border-bottom-light my-4 p-4"
  }, [_c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid || _vm.isEditingAGroup
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid || _vm.isEditingAGroup
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid || _vm.isEditingAGroup
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "topScheduleOptionsHolder d-flex mb-5"
  }, [_c('div', {
    staticClass: "availabilityHolder d-flex flex-grow-1"
  }, [_c('div', {
    staticClass: "panel mt-0"
  }, [_c('h5', [_vm._v("Availability - How to manage your resources availability.")]), _vm._v(" "), _c('div', {
    staticClass: "scheduleTypeHolder d-flex mt-2"
  }, [_vm._l((_vm.getAvailabilityTypes), function(availabilityType) {
    return _c('button', {
      staticClass: "btn tertiary",
      class: {
        'selected': _vm.form.availabilityType == availabilityType.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setAvailabiltyType(availabilityType)
        }
      }
    }, [_vm._v(_vm._s(availabilityType.label))])
  }), _vm._v(" "), (_vm.form.availabilityType == 0) ? _c('div', {
    staticClass: "ml-2",
    staticStyle: {
      "width": "180px"
    }
  }, [_c('label', {
    staticClass: "w-100"
  }, [_vm._v("Max. availability")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.capacity),
      expression: "form.capacity"
    }],
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.capacity)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "capacity", $event.target.value)
      }, function($event) {
        _vm.$v.form.capacity.$touch, _vm.productAcivateUpdateFlag('scheduleAvailability')
      }]
    }
  }), _vm._v(" "), (_vm.$v.form.capacity.$invalid) ? _c('div', {
    staticClass: "messages color-6"
  }, [(!_vm.$v.form.capacity.required) ? _c('span', [_vm._v("Please set max availability.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.capacity.customRequired) ? _c('span') : _vm._e()]) : _vm._e()]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "virtualRooster d-flex"
  }, [_c('div', {
    staticClass: "panel mt-0 d-flex flex-column flex-grow-1"
  }, [_c('h5', [_vm._v("Virtual Roster")]), _vm._v(" "), _c('div', {
    staticClass: "w-100 d-flex flex-row"
  }, [_c('div', {
    staticClass: "d-flex mr-2 pt-1"
  }, [_c('checkbox', {
    model: {
      value: (_vm.virtualRooster),
      callback: function($$v) {
        _vm.virtualRooster = $$v
      },
      expression: "virtualRooster"
    }
  })], 1), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between mb-2"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Schedule - Specify dates and hours for your activities.")]), _vm._v(" "), (_vm.form.id) ? _c('button', {
    staticClass: "btn tertiary",
    attrs: {
      "disabled": _vm.getIsDownloadingOldGroups,
      "type": "button"
    },
    on: {
      "click": _vm.togglePastGroups
    }
  }, [_vm._v(_vm._s(_vm.hidePastGroups ? 'Show' : 'Hide') + " older schedules")]) : _vm._e()]), _vm._v(" "), (_vm.isSpecial) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('table', {
    staticClass: "table narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.form.schedules), function(schedule, index) {
    return _c('tr', [_c('td', {
      staticClass: "pl-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (schedule.dateFrom),
        expression: "schedule.dateFrom"
      }],
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (schedule.dateFrom)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(schedule, "dateFrom", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "pl-3"
    }, [_c('timepicker', {
      attrs: {
        "defaultTime": _vm.fetchDefaultScheduleStartTime(schedule),
        "availableHours": _vm.durationHourSlots
      },
      on: {
        "change": function($event) {
          return _vm.setStartTime($event, schedule)
        }
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "pl-3"
    }, [(index > 0) ? _c('i', {
      staticClass: "ico-delete largest medium",
      on: {
        "click": function($event) {
          return _vm.deleteItem(index, 'schedules', schedule)
        }
      }
    }) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold mt-5",
    on: {
      "click": _vm.addScheduleSpecial
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new\n                                            ")])])]) : _c('div', [_vm._l((_vm.filteredGroups), function(group, index) {
    return (_vm.filteredGroups.length > 0) ? _c('div', {
      staticClass: "form-group schedule d-flex bg-lightest"
    }, [_c('div', {
      staticClass: "row w-100 pt-1 pl-3 pb-1 pr-0"
    }, [_c('div', {
      staticClass: "col-sm-12 my-2 d-flex justify-content-between align-items-center"
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.label),
        expression: "group.label"
      }],
      staticClass: "bg-lightest",
      staticStyle: {
        "width": "450px"
      },
      attrs: {
        "type": "text",
        "placeholder": "Schedule name",
        "disabled": !group.isEditing || group.isEditing == false
      },
      domProps: {
        "value": (group.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(group, "label", $event.target.value)
        }
      }
    }), _vm._v(" "), (group.isEdited && group.isEdited == true) ? _c('span', {
      staticClass: "fs-small dark ml-2"
    }, [_vm._v("edited")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [(!group.readOnly) ? _c('span', {
      staticClass: "bold darker fs-small mx-3 pointer",
      on: {
        "click": function($event) {
          return _vm.duplicateRow(group)
        }
      }
    }, [_vm._v("Duplicate")]) : _vm._e(), _vm._v(" "), (!group.readOnly) ? _c('span', {
      staticClass: "bold darker fs-small mx-3 pointer",
      on: {
        "click": function($event) {
          return _vm.deleteItem(index, 'groups', group)
        }
      }
    }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (!_vm.isCreatingProduct && !group.readOnly) ? _c('div', [(!group.isEditing || group.isEditing == false) ? _c('span', {
      staticClass: "bold darker fs-small mx-3 pointer",
      on: {
        "click": function($event) {
          return _vm.editGroupToggle(group)
        }
      }
    }, [_vm._v(_vm._s((group.isEditing && group.isEditing) ? 'Editing' : 'Edit'))]) : _vm._e(), _vm._v(" "), (group.isEditing && group.isEditing == true) ? _c('button', {
      staticClass: "btn tertiary mx-3",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.cancelEditGroup(group, index)
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (group.isEditing && group.isEditing == true) ? _c('button', {
      staticClass: "btn primary mx-3",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editGroupToggle(group)
        }
      }
    }, [_vm._v("Submit")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "ico mx-0 fs-normal pointer",
      class: {
        'ico-arrow-top': group.expanded, 'ico-arrow-bottom': !group.expanded
      },
      on: {
        "click": function($event) {
          return _vm.toggleGroupExpanded(group)
        }
      }
    })])]), _vm._v(" "), (group.expanded) ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "col-sm-12 panel shaded mt-0 mb-3"
    }, [_c('product-schedule-group-time-dates', {
      attrs: {
        "group": group,
        "form": _vm.form
      },
      on: {
        "update:group": function($event) {
          group = $event
        },
        "update": function($event) {
          return _vm.productAcivateUpdateFlag('schedule')
        }
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (group.expanded) ? _c('div', {
      staticClass: "col-md-6 pb-3"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "panel shadded mt-0"
    }, [_c('div', {
      staticClass: "d-flex pb-3 mb-3 border-bottom-light justify-content-between align-items-center pointer",
      on: {
        "click": function($event) {
          return _vm.toggleExpand(group)
        }
      }
    }, [_c('span', {
      staticClass: "font-weight-600"
    }, [_vm._v("PRICES")]), _vm._v(" "), _c('i', {
      staticClass: "ico mx-0 fs-normal",
      class: {
        'ico-arrow-top': group.pricesExpanded, 'ico-arrow-bottom': !group.pricesExpanded
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "panelHolder",
      class: {
        closed: !group.pricesExpanded
      },
      staticStyle: {
        "max-height": "none"
      }
    }, [_c('pricing-manager', {
      staticClass: "panel mt-0",
      attrs: {
        "disabled": !group.isEditing || group.isEditing == false,
        "group": group
      },
      model: {
        value: (group.productGenderPrices),
        callback: function($$v) {
          _vm.$set(group, "productGenderPrices", $$v)
        },
        expression: "group.productGenderPrices"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('resources-manager', {
      staticClass: "panel shaded",
      attrs: {
        "disabled": !group.isEditing || group.isEditing == false,
        "readOnly": group.readOnly,
        "form": _vm.form,
        "group": group
      }
    })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "px-2 py-3 text-center"
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.filteredGroups.length == 0) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('span', {
    staticClass: "dark fs-large w-100 text-center"
  }, [_vm._v("Looks like you have no active schedules, feel free to "), _c('b', {
    staticClass: "pointer",
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("add a new one")]), _vm._v("!")]), _vm._v(" "), (_vm.pastGroups.length > 0) ? _c('span', {
    staticClass: "dark fs-small w-100 text-center"
  }, [_vm._v("You have " + _vm._s(_vm.pastGroups.length) + " older schedule" + _vm._s(_vm.pastGroups.length > 1 ? 's' : '') + " that are hidden, "), _c('b', {
    staticClass: "pointer",
    on: {
      "click": _vm.togglePastGroups
    }
  }, [_vm._v("show all")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn tertiary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new schedule\n                                            ")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center border-bottom-light my-4 p-4"
  }, [_c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid || _vm.isEditingAGroup
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid || _vm.isEditingAGroup
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.form.$invalid || _vm.isEditingAGroup
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column flex-grow-1"
  }, [_c('div', {
    staticClass: "w-100 "
  }, [_vm._v("Do not allocate resources to this activity until the first booking in made. ")]), _vm._v(" "), _c('div', {
    staticClass: "w-100 dark"
  }, [_vm._v("\n                                                This allows you to share resources between different products on a first-come, first-served basis. "), _c('a', {
    staticClass: "color-1 underlined pointer",
    attrs: {
      "href": "https://intercom.help/pluralo/pt/articles/3215564",
      "target": "_blank"
    }
  }, [_vm._v("know more")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "pl-3"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "pl-3"
  }, [_vm._v("Starts")]), _vm._v(" "), _c('th', {
    staticClass: "pl-3"
  }, [_vm._v(" ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-b6f143f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6f143f2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductSchedule.vue
// module id = 1031
// module chunks = 0